<template>
    <s-form @submit="addItem" :key="formKey">
        <div class="row fl-x fl-j-sb ml-1">
            <h2 class="head font-poppins-semibold fs-lg-4 mt-3 text-primary">Unit Transfer</h2>
            <div>
                <btn class="px-4 mt-2 ml-1" style="cursor: pointer" @click="BackToList">Back</btn>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-8">
                <div class="row mt-4">
                    <div class="col-lg-1">
                        <validated-checkbox v-model="model.is_bull" label="Bulls" class="text-black"></validated-checkbox>
                    </div>
                    <div class="col-lg-1">
                        <validated-checkbox v-model="model.is_cow" label="Cow" class="text-black"></validated-checkbox>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-lg-3">
                        <validated-date-picker format="DD-MM-YYYY"  label="Date of Transfer" v-model="model.date_of_transfer" class="text-black c-input-datepicker  field-required" :disabled-date="disabledToDate" :rules="{required:true}"></validated-date-picker>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-lg-3">
                        <validated-select :options="animalOptions" label="Reg No" v-model="model.animal_id" @input="loadDetails" class="text-black field-required" :rules="{required:true}"></validated-select>
                    </div>
                    <div class="col-lg-3">
                        <validated-input label="UID Number" v-model="model.uid" class="text-black" disabled ></validated-input>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-lg-3">
                        <validated-input label="Registration Type" v-model="model.registration_type" class="text-black" disabled></validated-input>
                    </div>
                    <div class="col-lg-3">
                        <validated-input label="Source" v-model="model.source" class="text-black" disabled ></validated-input>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-lg-3">
                        <validated-input label="From Unit" v-model="model.from_unit" class="text-black field-required" :rules="{required:true}"></validated-input>
                    </div>
                    <div class="col-lg-3">
                        <validated-input label="To Unit" v-model="model.to_unit" class="text-black field-required" :rules="{required:true}"></validated-input>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-lg-6">
                        <validated-input label="Remarks" v-model="model.remarks" class="text-black"></validated-input>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-lg-6">
            <div class="col-12">
                <div class="fl-x fl-j-e">
                    <div class="btn-group">
                        <btn text="Save" :loading="loading" loading-text="Saving..." class="px-4"></btn>
                        <btn text="Cancel" type="reset" @click="BackToList" design="basic-b" class="px-4"></btn>
                    </div>
                </div>
            </div>
        </div>

    </s-form>
</template>

<script>
import urls from '../../data/urls';
import axios from 'secure-axios';

export default {
    name: 'UnitTransfer',
    components: { },
    data () {
        return {
            loading: false,
            URL: urls.unit_transfer.addEdit,
            bullURL: urls.bulls.vueSelects,
            cowURL: urls.cows.vueSelect,
            formKey: 0,
            model: {
                is_bull: false,
                is_cow: false,
                animal_id: '',
                date_of_transfer: '',
                uid: '',
                registration_type: '',
                source: '',
                from_unit: '',
                to_unit: '',
                remarks: ''
            },
            rules: {
                common: {
                    required: true,
                    customValidator: (value) => {
                        return this.validationDate(value);
                    }
                }
            },
            animaloptions: []
        };
    },
    methods: {
        disabledToDate (date) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return (
                date > today
            );
        },
        clearAnimalDetails () {
            this.model.date_of_transfer = '';
            this.model.animal_id = '';
            this.model.uid = '';
            this.model.registration_type = '';
            this.model.source = '';
            this.model.from_unit = '';
            this.model.to_unit = '';
            this.model.remarks = '';
        },
        async loadAnimal () {
            this.model.animal_id = '';
            this.animalOptions = [];
            let url = '';
            if (this.model.is_bull) {
                url = this.bullURL;
            } else if (this.model.is_cow) {
                url = this.cowURL;
            }
            if (!url) {
                return;
            }
            try {
                const response = await axios.get(url);
                if (response.data) {
                    this.animalOptions = response.data.data;
                }
            } catch (error) {
                console.error('Error loading animals:', error);
            }
        },
        async loadDetails () {
            if (!this.model.animal_id) {
                return;
            }
            try {
                const response = await axios.form(
                    urls.unit_transfer.animalDetail,
                    {
                        is_bull: this.model.is_bull,
                        is_cow: this.model.is_cow,
                        animal_id: this.model.animal_id
                    }
                );
                if (response.data && response.data.success) {
                    const data = response.data.data;
                    this.model.uid = data.uid || '';
                    this.model.registration_type = data.registration_type || '';
                    this.model.source = data.source || '';
                }
            } catch (error) {
                console.error('Error loading animal details:', error);
            }
        },
        async addItem () {
            try {
                this.loading = true;
                const response = await axios.form(this.URL, this.model);
                const result = response.data;
                if (result.success) {
                    this.$notify('Added Successfully', 'Success', { type: 'success' });
                    this.loading = false;
                    this.model = {
                        is_bull: '',
                        is_cow: '',
                        animal_id: '',
                        date_of_transfer: '',
                        from_unit: '',
                        to_unit: '',
                        remarks: ''
                    };
                    this.formKey++;
                } else {
                    const errors = response.data.errors;

                    for (const key in errors) {
                        if (Object.prototype.hasOwnProperty.call(errors, key)) {
                            const errorMessage = `${key}: ${errors[key]}`;
                            this.$notify('Warning', errorMessage, { type: 'warning' });
                        }
                    }
                    this.loading = false;
                }
            } catch (error) {
                this.$notify(
                    'Something Went Wrong..!!',
                    error.response.status + ' ' + error.response.statusText,
                    { type: 'danger' }
                );
                this.loading = false;
            }
        },
        BackToHome () {
            this.$router.push({ path: '/general/' });
        },
        BackToList () {
            this.$router.push({ path: '/unit-transfer-list/' });
        }
    },
    watch: {
        'model.is_bull' (after) {
            if (after) {
                this.model.is_cow = false;
                this.clearAnimalDetails();
                this.loadAnimal();
            } else {
                this.clearAnimalDetails();
                this.animalOptions = [];
            }
        },

        'model.is_cow' (after) {
            if (after) {
                this.model.is_bull = false;
                this.clearAnimalDetails();
                this.loadAnimal();
            } else {
                this.clearAnimalDetails();
                this.animalOptions = [];
            }
        }
    }
};
</script>

<style scoped lang="scss">
    .list-items, .list-contain ul {
        /*li:not(:nth-child(1)) {*/
        li {
            margin-top: var(--spacer-4);
            font-size: 0.9rem;
            font-family: poppins-medium;
            color: var(--text-3);

            > span {
                display: inline-block;
                max-width: 15rem;
            }

            display: flex;
            align-items: flex-start;
        }
    }
</style>
